import { __decorate, __metadata } from 'tslib';
import SchematicUIService from '../../controllers/base/schematic-ui-service.js';
import { ToggleMiddleware } from '../../middlewares/toggle-middleware/toggle-middleware.js';
import { Service } from '../../decorators/class/service.js';
import { MiddlewareService } from '../middleware/middleware-service.js';
import { ServiceCollection } from '../service-collection.js';
import { ServiceNames } from '../../constants/service-name.js';
import { ConfigWidgetService } from './config-widget-service.js';
import { ConfigControllerService } from './config-controller-service.js';
import { ConfigUIService } from './config-ui-service.js';
import { ConfigFeatureService } from './config-feature-service.js';
import { ConfigScopeService } from './config-scope-service.js';

/**
 * 功能配置服务
 * 利用中间件ToggleMiddleware拦截事件响应，被关闭的服务不再响应事件
 * ui上不在显示
 * @public
 */
let ConfigService = class ConfigService {
    constructor(serviceCollection, // ui service集合
    configWidgetService, configControllerService, configFeatureService, middlewareService, configUIService, configScopeService) {
        this.serviceCollection = serviceCollection;
        this.configWidgetService = configWidgetService;
        this.configControllerService = configControllerService;
        this.configFeatureService = configFeatureService;
        this.middlewareService = middlewareService;
        this.configUIService = configUIService;
        this.configScopeService = configScopeService;
        this.serviceCollection.getControllerRelatedUIServices().forEach((service, key) => {
            // TODO: 缺对所有接口的中间件注册
            if (service instanceof SchematicUIService) {
                this.middlewareService.use(ToggleMiddleware, { on: key, callbackNames: ['shouldHide'] });
            }
            this.middlewareService.use(ToggleMiddleware, { on: key, callbackNames: ['shouldDisabled'] });
        });
    }
    /**
     * 按服务名和item名禁用服务,按钮被隐藏。
     * @param serviceName - ui服务名称
     * @param name - config名称
     * @see {@link ServiceNames}
     * @see {@link WorkbenchUIConfig}
     */
    turnOffConfig(serviceName, name) {
        this.toggleService(serviceName, name, false);
    }
    /**
     * 按服务名和item名启用用服务
     */
    turnOnConfig(serviceName, name) {
        this.toggleService(serviceName, name, true);
    }
    /**
     * 关闭controller，被关闭的按钮被隐藏,点击不响应
     */
    turnOffController(name) {
        this.configControllerService.disableController(name);
    }
    /**
     * 打开controller开关
     */
    turnOnController(name) {
        this.configControllerService.enableController(name);
    }
    /**
     * 关闭feature 生命周期
     */
    turnOffFeature(name) {
        this.configFeatureService.disableFeature(name);
    }
    /**
     * 打开feature 生命周期
     */
    turnOnFeature(name) {
        this.configFeatureService.enableFeature(name);
    }
    /**
     * 打开同一scope的所有功能
     * @param name - controller和feature上的scope名称
     */
    turnOnByScope(name) {
        this.configScopeService.enableByScope(name);
    }
    /**
     * 关闭同一scope的所有功能
     * @param name - controller和feature上的scope名称
     */
    turnOffByScope(name) {
        this.configScopeService.disableByScope(name);
    }
    /**
     * 用来更新 Workbench 全局配置的方法
     *
     * @param options - 更新的配置对象
     */
    toggleService(serviceName, name, isOn) {
        const service = this.serviceCollection.getControllerRelatedUIServices().get(serviceName);
        if (service) {
            // 禁用ui服务
            this.configUIService.toggleUIService(service, name, isOn);
        }
        else if (serviceName === ServiceNames.FLOAT_WIDGET
            || serviceName === ServiceNames.EMBED_WIDGET
            || serviceName === ServiceNames.WRAPPED_WIDGET) {
            // 禁用widgetService
            this.configWidgetService.toggleWidgetService(serviceName, name, isOn);
        }
    }
};
ConfigService = __decorate([
    Service({ overridable: true }),
    __metadata("design:paramtypes", [ServiceCollection,
        ConfigWidgetService,
        ConfigControllerService,
        ConfigFeatureService,
        MiddlewareService,
        ConfigUIService,
        ConfigScopeService])
], ConfigService);

export { ConfigService };
//# sourceMappingURL=config-service.js.map
